/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentTemplateComponent from './treatment-template-component';
import TreatmentTemplateComponentDetail from './treatment-template-component-detail';
import TreatmentTemplateComponentUpdate from './treatment-template-component-update';
import TreatmentTemplateComponentDeleteDialog from './treatment-template-component-delete-dialog';

const TreatmentTemplateComponentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentTemplateComponent />} />
    <Route path="new" element={<TreatmentTemplateComponentUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentTemplateComponentDetail />} />
      <Route path="edit" element={<TreatmentTemplateComponentUpdate />} />
      <Route path="delete" element={<TreatmentTemplateComponentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentTemplateComponentRoutes;
